import React from 'react';

/**
 * Reusable Payment Collection component
 * Displays payment status (YES/NO) and payment comment
 * @param {Object} props
 * @param {string} props.paymentStatus - Payment status ('yes' or 'no')
 * @param {string} props.paymentComment - Payment comment/note
 * @param {string} props.className - Additional CSS classes
 */
export const PaymentCollection = ({ paymentStatus, paymentComment, className = '' }) => {
    if (!paymentStatus && !paymentComment) {
        return null;
    }

    return (
        <div className={`flex flex-col gap-1 text-xs ${className}`}>
            {paymentStatus && (
                <div className="flex items-center gap-1.5">
                    <span className="text-gray-600 font-medium">Payment:</span>
                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                        paymentStatus.toLowerCase() === 'yes' 
                            ? 'bg-green-100 text-green-700' 
                            : 'bg-red-100 text-red-700'
                    }`}>
                        {paymentStatus.toLowerCase() === 'yes' ? 'Collected' : 'Not Collected'}
                    </span>
                </div>
            )}
            {paymentComment && (
                <div className="text-gray-600">
                    <span className="font-medium">Note: </span>
                    <span>{paymentComment}</span>
                </div>
            )}
        </div>
    );
};
